module.exports = __webpack_public_path__ + "img/seiran_lw.e6bc163b.png";